import "./Footer.css";

import { useData } from "../../consts";
import { useEffect, useState } from "react";

export default function Footer(){
    const {siteData} = useData();
    const [footPanels, setFootPanels] = useState([]);

    useEffect(_=>{
        let _footPanels=[];
        try{
            _footPanels = JSON.parse(siteData.footPanels || `[]`);
        }catch(err){
            console.log('foot panels error:', err);
            _footPanels = [];
        }

        setFootPanels(_footPanels);
    }, [siteData]);

    return <>
        <footer className="">
            <div className="jumbotron p-5 container text-white">
                <div className="row">
                    {
                        (footPanels||[]).map((footPanelDef,fpIdx)=>{

                            return <div className="col-md-4 text-left"
                                key={`foot-panel-${fpIdx}`}
                                dangerouslySetInnerHTML={{ __html: (footPanelDef.html || `<h2>${footPanelDef.title}</h2><p>${footPanelDef.content}</p>`) }}
                            >
                            </div>;
                        })
                    }
                    
                    {/* <div className="col-md-4 text-left">
                        <h4>links</h4>
                        <p></p>
                    </div>
                    <div className="col-md-4 text-left">
                        <h4>Contact us</h4>
                        <p className="lead text-white">contact us</p>
                    </div> */}
                </div>
            </div>
        </footer>    
    </>;
}